import { createFileRoute, redirect } from "@tanstack/react-router";
import { buildHref } from "@softmax/web-addresses";

export const Route = createFileRoute("/_site/account/advanced")({
  beforeLoad: () => {
    throw redirect({ href: buildHref({ name: "account" }) });
  },
});
